import type { AnafCompanyData, CreateClientInput, ImportPreview, ImportResult, UpdateClientInput } from '@financiar/shared';
import { apiClient } from '../../api/client';
import type { Client, ListParams, Paginated } from '../../api/types';

/** Precompletare din registrul public ANAF, după CUI (cu sau fără prefix RO). */
export async function fetchAnafCompany(cui: string): Promise<AnafCompanyData> {
  const { data } = await apiClient.get<AnafCompanyData>(`/anaf/company/${encodeURIComponent(cui)}`);
  return data;
}

export async function fetchClienti(params: ListParams & { companyId: string }): Promise<Paginated<Client>> {
  const { data } = await apiClient.get<Paginated<Client>>('/clients', { params });
  return data;
}

export async function fetchClient(id: string): Promise<Client> {
  const { data } = await apiClient.get<Client>(`/clients/${id}`);
  return data;
}

export async function createClient(input: CreateClientInput): Promise<Client> {
  const { data } = await apiClient.post<Client>('/clients', input);
  return data;
}

export async function updateClient(id: string, input: UpdateClientInput): Promise<Client> {
  const { data } = await apiClient.patch<Client>(`/clients/${id}`, input);
  return data;
}

export async function deleteClient(id: string): Promise<void> {
  await apiClient.delete(`/clients/${id}`);
}

/** Parses an uploaded .xls/.xlsx/.csv file and returns a preview (mapped
 * rows, ANAF VAT status, new/duplicate/error classification) — writes
 * nothing server-side. `file` is sent as multipart form-data; axios sets the
 * multipart Content-Type + boundary automatically for a `FormData` body. */
export async function previewClientImport(companyId: string, file: File): Promise<ImportPreview> {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await apiClient.post<ImportPreview>('/clients/import/preview', formData, { params: { companyId } });
  return data;
}

/** Actually creates the given clients (normally the preview's 'new' rows'
 * `client` payloads, copied verbatim). */
export async function commitClientImport(companyId: string, clients: CreateClientInput[]): Promise<ImportResult> {
  const { data } = await apiClient.post<ImportResult>('/clients/import', { companyId, clients });
  return data;
}
